import { Vec3 } from '../math/vec3'
import { Quat } from '../math/quat'

/**
 * Istanza di una parte montata su un veicolo.
 * A differenza del resto di core/, questo oggetto e MUTABILE: `propellant`
 * cambia a ogni tick e copiarlo sarebbe uno spreco. E lo stato della simulazione.
 */
export interface PartInstance {
  readonly id: string
  readonly defId: string
  /** posizione nel sistema locale del veicolo (origine = radice) */
  readonly position: Vec3
  readonly rotation: Quat
  readonly stage: number
  readonly parentId: string | null
  /** propellente attualmente contenuto, kg */
  propellant: number
}

export interface Vessel {
  readonly parts: PartInstance[]
  readonly rootId: string
}

export function partById(vessel: Vessel, id: string): PartInstance {
  const p = vessel.parts.find((x) => x.id === id)
  if (!p) throw new Error(`Parte non montata sul veicolo: ${id}`)
  return p
}

export const childrenOf = (vessel: Vessel, id: string): PartInstance[] =>
  vessel.parts.filter((p) => p.parentId === id)

/** Antenati dal piu vicino al piu lontano, radice compresa. */
export function ancestorsOf(vessel: Vessel, id: string): PartInstance[] {
  const out: PartInstance[] = []
  let cur = partById(vessel, id).parentId
  while (cur !== null) {
    const p = partById(vessel, cur)
    out.push(p)
    cur = p.parentId
  }
  return out
}

/** Tutte le parti a valle di una data, la parte stessa compresa. */
export function subtreeOf(vessel: Vessel, id: string): PartInstance[] {
  const out: PartInstance[] = [partById(vessel, id)]
  for (let i = 0; i < out.length; i++) {
    out.push(...childrenOf(vessel, out[i]!.id))
  }
  return out
}

export const partsInStage = (vessel: Vessel, stage: number): PartInstance[] =>
  vessel.parts.filter((p) => p.stage === stage)

export const maxStage = (vessel: Vessel): number =>
  vessel.parts.reduce((m, p) => Math.max(m, p.stage), 0)

export const totalPropellant = (vessel: Vessel): number =>
  vessel.parts.reduce((s, p) => s + p.propellant, 0)
